"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTemplateRequiredInVariantSuggestion = instanceOfTemplateRequiredInVariantSuggestion;
exports.TemplateRequiredInVariantSuggestionFromJSON = TemplateRequiredInVariantSuggestionFromJSON;
exports.TemplateRequiredInVariantSuggestionFromJSONTyped = TemplateRequiredInVariantSuggestionFromJSONTyped;
exports.TemplateRequiredInVariantSuggestionToJSON = TemplateRequiredInVariantSuggestionToJSON;
exports.TemplateRequiredInVariantSuggestionToJSONTyped = TemplateRequiredInVariantSuggestionToJSONTyped;
const zoneLocationsEnum_1 = require("./zoneLocationsEnum");
/**
 * Check if a given object implements the TemplateRequiredInVariantSuggestion interface.
 */
function instanceOfTemplateRequiredInVariantSuggestion(value) {
    if (!('template' in value) || value['template'] === undefined)
        return false;
    if (!('quantity' in value) || value['quantity'] === undefined)
        return false;
    if (!('scryfallQuery' in value) || value['scryfallQuery'] === undefined)
        return false;
    if (!('zoneLocations' in value) || value['zoneLocations'] === undefined)
        return false;
    if (!('battlefieldCardState' in value) || value['battlefieldCardState'] === undefined)
        return false;
    if (!('exileCardState' in value) || value['exileCardState'] === undefined)
        return false;
    if (!('libraryCardState' in value) || value['libraryCardState'] === undefined)
        return false;
    if (!('graveyardCardState' in value) || value['graveyardCardState'] === undefined)
        return false;
    if (!('mustBeCommander' in value) || value['mustBeCommander'] === undefined)
        return false;
    return true;
}
function TemplateRequiredInVariantSuggestionFromJSON(json) {
    return TemplateRequiredInVariantSuggestionFromJSONTyped(json, false);
}
function TemplateRequiredInVariantSuggestionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'template': json['template'],
        'quantity': json['quantity'],
        'scryfallQuery': json['scryfallQuery'],
        'zoneLocations': (json['zoneLocations'].map(zoneLocationsEnum_1.ZoneLocationsEnumFromJSON)),
        'battlefieldCardState': json['battlefieldCardState'],
        'exileCardState': json['exileCardState'],
        'libraryCardState': json['libraryCardState'],
        'graveyardCardState': json['graveyardCardState'],
        'mustBeCommander': json['mustBeCommander'],
    };
}
function TemplateRequiredInVariantSuggestionToJSON(json) {
    return TemplateRequiredInVariantSuggestionToJSONTyped(json, false);
}
function TemplateRequiredInVariantSuggestionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'template': value['template'],
        'quantity': value['quantity'],
        'scryfallQuery': value['scryfallQuery'],
        'zoneLocations': (value['zoneLocations'].map(zoneLocationsEnum_1.ZoneLocationsEnumToJSON)),
        'battlefieldCardState': value['battlefieldCardState'],
        'exileCardState': value['exileCardState'],
        'libraryCardState': value['libraryCardState'],
        'graveyardCardState': value['graveyardCardState'],
        'mustBeCommander': value['mustBeCommander'],
    };
}
//# sourceMappingURL=templateRequiredInVariantSuggestion.js.map